import { Component } from '@angular/core';

@Component({
  selector: 'app-user-exceed-limits',
  imports: [],
  templateUrl: './user-exceed-limits.html',
  styleUrl: './user-exceed-limits.scss',
})
export class UserExceedLimits {}
